import {
  Box,
  TypographyStylesProvider,
  Image,
  Alert,
  Text,
  Code,
} from "@mantine/core";
import React from "react";

import SimpleImage from "../articlesHelpers/SimpleImage";
import { IconAlertTriangle } from "@tabler/icons-react";

export const USE_RIZFUL_WITH_STACKER_NEWS = (
  <TypographyStylesProvider>
    <p>
      You can use NWC (Nostr Wallet Connect) to send and receive zaps on{" "}
      <img
        src="https://daxwktpz4hkwd.cloudfront.net/docs_images/stacker-news-logo.avif"
        alt="Stacker News Logo"
        style={{ height: "1em", verticalAlign: "middle" }}
      />{" "}
      Stacker News. Let's walk through the process of setting it up.
    </p>
    <p>
      1. Go to your <code>wallet</code> preferences in Stacker News.
    </p>
    <SimpleImage src="docs_images/stacker-news-go-to-wallet.png" h={180} />
    <p>
      2. Choose <code>attach wallets</code>
    </p>
    <SimpleImage src="docs_images/go-to-attach-wallets.png" h={220} />
    <p>
      3. Choose <code>NWC</code>
    </p>
    <SimpleImage src="docs_images/choose-nwc.png" h={220} />

    <p>
      4. You will see that Stacker News wants a connection for sending, and a
      connection for receiving.
    </p>
    <SimpleImage
      src="docs_images/stacker-news-needs-two-connections.png"
      h={320}
    />

    <Alert mt="20px" mb="20px" icon={<IconAlertTriangle size={36} />}>
      <Text size="md">
        Currently, Stacker news requires TWO different NWC connections. You need
        a "Send & Receive" connection for sending, and a "Receive Only"
        connection for receiving.{" "}
      </Text>
    </Alert>
    <p>
      5. Follow{" "}
      <a
        href="/docs/connecting-apps#nostr-wallet-connect-send-and-receive"
        target="_blank"
      >
        these instructions
      </a>{" "}
      to get a <strong>NWC Send & Receive Connection</strong> code for sending.{" "}
      Put this in the{" "}
      <Code>
        {" "}
        <strong>connection </strong>for sending
      </Code>{" "}
      field.
    </p>

    <p>
      6. Follow{" "}
      <a
        href="/docs/connecting-apps#nostr-wallet-connect-receive-only"
        target="_blank"
      >
        these instructions
      </a>{" "}
      to get a NWC Receive Only code for receiving. Put this in the{" "}
      <Code>
        {" "}
        <strong>connection </strong>for receiving
      </Code>{" "}
      field.
    </p>
    <p>Copy the codes into the appropriate fields in Stacker News. </p>
    <p>
      7. For maximum success rate, we recommend setting both{" "}
      <code>max fee rate</code> and <code>max fee total</code> both to{" "}
      <code>5</code>. You can adjust this however as you like.
    </p>
    <SimpleImage
      src="docs_images/max-success-rate-choose-these-values.png"
      h={580}
    />
    <p>8. Click `attach` to save your wallet connection.</p>
  </TypographyStylesProvider>
);
